export function containmentPaths (targetObject, root, keysOnly = false, fullPath = false) {
  const visited = new WeakSet()
  const paths = []

  function search (currentObject, currentPath) {
    // Check if the current object is the target
    if (currentObject === targetObject) {
      if (!keysOnly) {
        const currentObjectDescription = getDescriptionOfCurrentObject(currentObject)
        if (currentObjectDescription) {
          currentPath.push(currentObjectDescription)
        }
      }

      paths.push(currentPath.join(keysOnly ? '.' : '->'))
      return
    }

    // Avoid cycles and check if the object is suitable for traversal
    if ((typeof currentObject !== 'object' && typeof currentObject !== 'function') || currentObject === null || visited.has(currentObject)) {
      return
    }
    visited.add(currentObject)

    // Iterate over properties of the object
    for (const key of Object.getOwnPropertyNames(currentObject)) {
      try {
        // Using a binding function to correctly handle getters
        const propertyDescriptor = Object.getOwnPropertyDescriptor(currentObject, key)
        if (propertyDescriptor) {
          if ('value' in propertyDescriptor && typeof propertyDescriptor.value === 'object') {
            const nextPath = [...currentPath]
            // Do we want descriptive path of full path
            if (keysOnly) {
              nextPath.push(key)
            } else {
              const currentObjectDescription = getDescriptionOfCurrentObject(currentObject)
              if (currentObjectDescription) {
                nextPath.push(`(${currentObjectDescription}).${key}`)
              } else if (fullPath) {
                nextPath.push(key)
              }
            }

            search(propertyDescriptor.value, nextPath) // Continue with the actual value
          } else if ('get' in propertyDescriptor && propertyDescriptor.get) {
            continue
          }
        }
      } catch (e) {
        // Handle errors specifically from inaccessible properties
        console.error('Failed to access property', key, ':', e)
      }
    }
  }

  const rootDescription = getDescriptionOfCurrentObject(root) || 'Root'
  search(root, [rootDescription])

  return _.uniq(paths) // Return unique paths (only matters for non-full paths)
}

function getDescriptionOfCurrentObject (currentObject) {
  // If this is a Vue component, return the component name
  if (Object.getOwnPropertyNames(currentObject).includes('$options') && currentObject.$options.name) {
    if (currentObject._isDestroyed) {
      return `${currentObject.$options.name}{V}(destroyed)`
    }

    return `${currentObject.$options.name}{V}`
  }

  // If this is a Model instance, return the model name
  if (Object.getOwnPropertyNames(currentObject).includes('computedFieldNames') && currentObject.isModel) {
    return `${currentObject.typeName}{${currentObject.isCollection ? 'C' : 'M'}}${currentObject.destroyed ? '(destroyed)' : ''}`
  }

  // For other objects, return null
  return null
}
